import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { creditApplicationSelectors } from '../../data/store/CreditApplicationStore'
import { useAppSelector } from '../../data/store'
import FinalDecisionApprovedForm from './FinalDecisionApprovedForm'
import FinalDecisionRefusedForm from './FinalDecisionRefusedForm'
import FinalDecisionManualRevision from './FinalDecisionManualRevision'
import { Enum } from '../../data/types/constants'
import Loader from '../components/Loader'
import CreditApplicationContainerStepProgressIcon from './CreditApplicationContainerStepProgressIcon'
import CreditReportError from './CreditReportError'
import { creditApplicationStateSelectors } from '../../data/creditApplicationStateSelectors'
import { trackingEvents } from '../utils/trackingEvents'

function FinalDecisionContainer() {
  const { t } = useTranslation()
  const { id } = useParams()
  const navigate = useNavigate()
  const creditApplication = useAppSelector(creditApplicationSelectors.getFilteredCreditApplication)
  const hasRequiredDocumentPendingForUpload =
    creditApplicationStateSelectors.hasRequiredDocumentPendingForUpload(creditApplication)

  const stepProgression = <CreditApplicationContainerStepProgressIcon currentStep={2} />

  const gotoAddCoapplicant = (event: { preventDefault: () => void } | null) => {
    navigate(`/creditApplication/${id as string}/coapplicant`)
    if (event) event.preventDefault()
  }

  const prequalificationAmount = Math.min(
    creditApplication?.requestedLoanAmount ?? Number.MAX_VALUE,
    creditApplication?.prequalificationDecision?.maxLoanAmount ?? Number.MAX_VALUE,
  )

  const cancelMyApp = (event: { preventDefault: () => void }) => {
    trackingEvents.withdrewAfterPrequal({
      credit_application_id: id as string,
      reference_number: creditApplication?.referenceNumber as number,
      amount: prequalificationAmount,
    })
    navigate(`/creditApplication/${id as string}/reportFeedback`, { replace: true })
    event.preventDefault()
  }

  const renderExternalStep = (event: { preventDefault: () => void }) => {
    navigate(`/creditApplication/${id as string}/income-verification`)
    event.preventDefault()
  }

  const renderCreditContainer = () => {
    window.location.reload()
  }

  return (
    <div>
      {(creditApplication == null || creditApplication?.finalDecision.decision === Enum.EFinalDecision.Pending) && (
        <Loader
          title={t('finalDecision.processing')}
          description={`${t('common.pleaseWait')} ${t('common.withYouShortly')}`}
        />
      )}

      {creditApplication?.finalDecision.decision === Enum.EFinalDecision.Approved && (
        <FinalDecisionApprovedForm
          onSubmit={renderExternalStep}
          cancelMyApp={cancelMyApp}
          gotoAddCoapplicant={() => gotoAddCoapplicant(null)}
          stepProgression={stepProgression}
        />
      )}

      {creditApplication?.finalDecision.decision === Enum.EFinalDecision.Refused && (
        <FinalDecisionRefusedForm
          onSubmit={gotoAddCoapplicant}
          cancelMyApp={cancelMyApp}
          hasCoapplicant={creditApplication?.hasCoapplicant}
          stepProgression={stepProgression}
        />
      )}

      {creditApplication?.finalDecision.decision === Enum.EFinalDecision.ManualRevision && (
        <FinalDecisionManualRevision
          onSubmit={renderExternalStep}
          stepProgression={stepProgression}
          hasPendingDocument={hasRequiredDocumentPendingForUpload}
          renderCreditContainer={renderCreditContainer}
        />
      )}
      {creditApplication?.finalDecision.decision === Enum.EFinalDecision.Error && <CreditReportError />}
    </div>
  )
}

export default FinalDecisionContainer
